import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { InsuranceAdapter } from './dto/insurance.adapter';
import { Insurance } from './dto/insurance.entity';
import { InsuranceController } from './insurance.controller';
import { InsuranceService } from './insurance.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([Insurance]),
  ],
  controllers: [InsuranceController],
  providers: [InsuranceService,ApplicationExceptionHandler,InsuranceAdapter,LogsService]
})
export class InsuranceModule {}
